import { ResolvedPassport } from '@/utils/passport/concurrent';

/** 임직원 카드에 노출되는 직책 배지 종류. */
export type PositionBadgeType = 'teamLeader' | 'partLeader' | 'concurrent';

/**
 * 배지 라벨. i18n 키로 그대로 사용한다(`public/translations/{ko,en,zh}/common.json`).
 */
export const POSITION_BADGE_LABEL: Record<PositionBadgeType, string> = {
  teamLeader: '팀장',
  partLeader: '파트장',
  concurrent: '겸직',
};

/**
 * 표시할 직책 배지 목록을 계산합니다.
 *
 * 반환 순서는 팀장 > 파트장 > 겸직 으로, 목록 정렬 기준
 * (`DefaultOrganization`, hooks/apiHooks/index.ts)과 같은 우선순위입니다.
 *
 * **팀장 대행은 배지를 만들지 않습니다.** 포탈 전체에서 '팀장 대행'을 표시하는 곳은
 * 없고 정렬에서만 위로 올린다는 확정 사항입니다
 * (PORTAL-13653 코멘트 198722, 2026-08-25). 판정은 정렬 키
 * (`detail.isActingTeamLeader,desc`) 쪽에만 남아 있고, 라벨 i18n 키도 제거했습니다.
 * 여기에 배지를 다시 추가하면 "라벨 없이 위에 있는" 상태가 깨집니다.
 *
 * 직책 레이블은 `detail.isLeader`, `detail.isPartLeader`로만 판정합니다.
 * 겸직 카드에서는 해당 겸직 소속의 직책으로 변환한 detail을 사용합니다.
 * 조직 관점에서는 겸직 소속 카드에만 겸직 라벨을 표시합니다.
 * 인물 관점의 겸직 여부는 resolveAsPerson에서 확정한 값을 따릅니다.
 *
 * @param passport 관점이 확정된 Passport
 */
export function getPositionBadges(
  passport: ResolvedPassport,
): PositionBadgeType[] {
  const { detail } = passport;
  const badges: PositionBadgeType[] = [];

  if (detail.isLeader) badges.push('teamLeader');
  if (detail.isPartLeader) badges.push('partLeader');
  if (passport.isConcurrent) badges.push('concurrent');

  return badges;
}
